import React, { useState, useContext, useEffect } from 'react'
import { Content, Title, Wrapper } from '../styles/elements'
import { NextSeason } from '../styles/season'
import { TogglePlanets } from '../styles/planet'
import PairButtons from './common/PairButtons'
import GiftList from './GiftList'
import { LocaleContext } from '../routes'
import { Toggle } from '../styles/image'
import ExpandIcon from '../assets/icons/expand.svg'
import { HomeBodyPlanets } from '../styles/'
import HomePlanets from './HomePlanets'
import { getAd } from '../api'
import { Banner } from '../styles/image'
import { Ads, HomeBody } from '../styles/home'

const useAds = () => {
  const [ads, setAds] = useState()
  useEffect(() => {
    const getAds = async () => {
      const adsResponse = await getAd()
      setAds(adsResponse)
    }
    getAds()
  }, [])
  return ads
}

export default ({
  finishedRides,
  planets,
  nextSeason,
  featuredItems,
  point,
}) => {
  const getNextSeasonPlanetType = () => {
    const nextSeasonPlanet = planets.find((planet, planetIndex) =>
      planet.minNumOfRides <= finishedRides &&
      planetIndex < (planets.length - 1) &&
      planets[planetIndex + 1].minNumOfRides > finishedRides
    )
    return nextSeasonPlanet ? nextSeasonPlanet.type : 'GALAXY'
  }

  const locale = useContext(LocaleContext)

  const [isShown, setShown] = useState()
  const toggle = () => setShown(!isShown)

  if (!Array.isArray(planets) || !planets.length) return <div />

  const planetType = getNextSeasonPlanetType()

  planets = planets.map((planet, index) => ({
    ...planet,
    index,
    isFirstPlanet: index === 0,
    isLastPlanet: index === planets.length - 1
  }))
  const planetsTypes = planets.map(planet => planet.type)
  const currentPlanetIndex = planetsTypes.indexOf(planetType)

  const passedPlanets = planets.slice(0, currentPlanetIndex)
  const currentPlanet = planets[currentPlanetIndex]
  const toPassPlanets = planets.slice(currentPlanetIndex + 1)

  const ads = useAds()
  const ad = ads && ads.loyaltyClubBanner

  return (
    <HomeBody>
      <HomeBodyPlanets>
        <br />
        <NextSeason>
          <Title color="black">
            {locale.CHOOSE_DESTINATION} {nextSeason.title.split(' ')[0]}
          </Title>
          <Content>{nextSeason.text}</Content>
        </NextSeason>

        <HomePlanets
          partPlanets={passedPlanets}
          planets={planets}
          isPassed
          isShown={isShown}
          planetType={planetType}
          finishedRides={finishedRides}
        />
        <HomePlanets
          partPlanets={[currentPlanet]}
          planets={planets}
          isCurrent
          isShown
          planetType={planetType}
          finishedRides={finishedRides}
        />
        <HomePlanets
          partPlanets={toPassPlanets}
          planets={planets}
          isShown={isShown}
          planetType={planetType}
          finishedRides={finishedRides}
        />
        <TogglePlanets onClick={toggle}>
          {isShown ? locale.LESS_ITEMS : locale.MORE_ITEMS}
          <Toggle src={ExpandIcon} alt="" collapsed={isShown} width="12px" />
        </TogglePlanets>
      </HomeBodyPlanets>
      {ad &&
        <Ads>
          <Banner src={ad.image} alt={ad.title} onClick={() => window.open(ad.webLink.url, '_blank')} />
        </Ads>
      }
      <Wrapper>
        <PairButtons
          leftButton={{ text: 'purchases', invert: true, isIcon: true }}
          rightButton={{ text: 'store', isIcon: true }}
        />
        {!!featuredItems && !!featuredItems.length &&
          <GiftList
            point={point}
            title={locale.BEST_GIFTS}
            items={featuredItems}
            isHome
          />
        }
      </Wrapper>
    </HomeBody>
  )
}
